module.exports = __webpack_public_path__ + "img/Buro.c6ac4af9.svg";